import { Box, Typography, useTheme } from "@mui/material";
import { motion } from "framer-motion";
import SignupComponent from "../components/SignupComponent";
import Layout from "../components/layout/LandingPageLayout";

const Signup = () => {
  const theme = useTheme();

  const logoVariants = {
    initial: { scale: 1, rotate: 0 },
    animate: {
      scale: [1, 1.05, 1],
      rotate: [0, 2, -2, 0],
      transition: {
        duration: 6,
        repeat: Infinity,
        ease: "easeInOut",
      },
    },
  };

  return (
    <Layout>
      <Box
        sx={{
          height: "100vh",
          width: "100vw",
          background: theme.palette.background.default,
          display: "flex",
          overflow: "hidden",
        }}
      >
        <Box
          sx={{
            width: { xs: "100%", md: "50%" },
            height: "100%",
            background:
              theme.palette.mode === "dark"
                ? `linear-gradient(135deg, ${theme.palette.secondary.dark} 0%, ${theme.palette.secondary.main} 100%)`
                : `linear-gradient(135deg, ${theme.palette.secondary.main} 0%, ${theme.palette.secondary.light} 100%)`,
            display: { xs: "none", md: "flex" },
            alignItems: "center",
            justifyContent: "center",
            position: "relative",
          }}
        >
          <Box
            sx={{
              position: "absolute",
              top: 0,
              left: 0,
              right: 0,
              bottom: 0,
              backgroundImage: `radial-gradient(circle at 25% 25%, rgba(255,255,255,0.1) 0%, transparent 50%), 
                             radial-gradient(circle at 75% 75%, rgba(255,255,255,0.05) 0%, transparent 50%)`,
            }}
          />

          <Box
            sx={{
              textAlign: "center",
              position: "relative",
              zIndex: 1,
            }}
          >
            <Box
              component={motion.div}
              variants={logoVariants}
              initial="initial"
              animate="animate"
              sx={{
                width: { xs: 120, md: 150, lg: 180 },
                height: { xs: 120, md: 150, lg: 180 },
                borderRadius: "50%",
                background: "rgba(255, 255, 255, 0.15)",
                backdropFilter: "blur(10px)",
                border: "2px solid rgba(255, 255, 255, 0.2)",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                mb: 4,
                mx: "auto",
              }}
            >
              <img
                src="/failogo.jpg"
                alt="Logo"
                style={{ height: "200px", width: "200px", marginRight: "8px" }}
              />
            </Box>

            <Box
              sx={{
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
              }}
            >
              <Box sx={{ textAlign: "center" }}>
                <Box
                  sx={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    mb: 1,
                  }}
                >
                  <Typography
                    variant="h2"
                    component="span"
                    sx={{
                      color: "black",
                      fontSize: { xs: "3rem", md: "4rem", lg: "5rem" },
                      fontWeight: "bold",
                    }}
                  >
                    f-
                  </Typography>
                  <Typography
                    variant="h2"
                    component="span"
                    sx={{
                      color: theme.palette.primary.main,
                      fontSize: { xs: "3rem", md: "4rem", lg: "5rem" },
                      fontWeight: "bold",
                    }}
                  >
                    ai
                  </Typography>
                  <Typography
                    variant="h2"
                    component="span"
                    sx={{
                      color: "black",
                      fontSize: { xs: "3rem", md: "4rem", lg: "5rem" },
                      fontWeight: "bold",
                    }}
                  >
                    .in
                  </Typography>
                </Box>
              </Box>
            </Box>

            <Typography
              variant="h6"
              sx={{
                fontWeight: 400,
                mb: 3,
                fontSize: { xs: "1rem", md: "1.25rem" },
              }}
            >
              Join Our Platform
            </Typography>

            <Box
              component={motion.div}
              animate={{
                opacity: [0.6, 1, 0.6],
              }}
              transition={{
                duration: 3,
                repeat: Infinity,
                ease: "easeInOut",
              }}
            >
              <Typography
                variant="body1"
                sx={{
                  fontStyle: "italic",
                  fontSize: { xs: "0.9rem", md: "1rem" },
                  mb: 2,
                }}
              >
                Create your account and start managing
              </Typography>
              <Typography
                variant="body1"
                sx={{
                  fontStyle: "italic",
                  fontSize: { xs: "0.9rem", md: "1rem" },
                }}
              >
                your finances with AI-powered tools
              </Typography>
            </Box>
          </Box>
        </Box>

        <Box
          sx={{
            width: { xs: "100%", md: "50%" },
            height: "100%",
            background: theme.palette.background.paper,
            display: "flex",
            flexDirection: "column",
            position: "relative",
            p: "2%",
          }}
        >
          <Box
            sx={{
              flex: 1,
              width: "100%",
              display: "flex",
              flexDirection: "column",
              justifyContent: "center",
              alignItems: "center",
            }}
          >
            <SignupComponent />
          </Box>
        </Box>
      </Box>
    </Layout>
  );
};

export default Signup;
